import { ShopperAgentAggregateInsightKind } from "@redotech/cockroachdb-codegen/tables/shopper-ai/shopper-agent-aggregate-insight-kind";
import { Schema } from "effect";
import {
  ChannelThreadId,
  MessageId,
  ShopperAgentAggregateInsightRunId,
  TopicId,
} from "../../../ids/definitions";
import { Message } from "./message";

export const ShopperAgentAggregateInsightType = Schema.Enums(
  ShopperAgentAggregateInsightKind,
);
export type ShopperAgentAggregateInsightType =
  typeof ShopperAgentAggregateInsightType.Type;

export const ShopperAgentAggregateInsightSummary = Schema.Struct({
  topicId: TopicId,
  insightType: ShopperAgentAggregateInsightType,
  title: Schema.String,
});
export type ShopperAgentAggregateInsightSummary =
  typeof ShopperAgentAggregateInsightSummary.Type;

export const ShopperAgentAggregateInsightRunSummary = Schema.Struct({
  id: ShopperAgentAggregateInsightRunId,
  windowStart: Schema.Date,
  windowEnd: Schema.Date,
  insights: Schema.Array(ShopperAgentAggregateInsightSummary),
});
export type ShopperAgentAggregateInsightRunSummary =
  typeof ShopperAgentAggregateInsightRunSummary.Type;

export const ShopperAgentAggregateInsightRunListResponse = Schema.Struct({
  runs: Schema.Array(ShopperAgentAggregateInsightRunSummary),
});
export type ShopperAgentAggregateInsightRunListResponse =
  typeof ShopperAgentAggregateInsightRunListResponse.Type;

export const ShopperAgentAggregateInsightEvidenceSpan = Schema.Struct({
  startMessageId: MessageId,
  endMessageId: MessageId,
  messages: Schema.Array(Message),
});
export type ShopperAgentAggregateInsightEvidenceSpan =
  typeof ShopperAgentAggregateInsightEvidenceSpan.Type;

export const ShopperAgentAggregateInsightEvidenceConversation = Schema.Struct({
  conversationTopicId: TopicId,
  channelThreadId: ChannelThreadId,
  spans: Schema.Array(ShopperAgentAggregateInsightEvidenceSpan),
});
export type ShopperAgentAggregateInsightEvidenceConversation =
  typeof ShopperAgentAggregateInsightEvidenceConversation.Type;

export const ShopperAgentAggregateInsightDetailResponse = Schema.Struct({
  topicId: TopicId,
  runId: ShopperAgentAggregateInsightRunId,
  windowStart: Schema.Date,
  windowEnd: Schema.Date,
  insightType: ShopperAgentAggregateInsightType,
  title: Schema.String,
  description: Schema.String,
  evidenceConversations: Schema.Array(
    ShopperAgentAggregateInsightEvidenceConversation,
  ),
});
export type ShopperAgentAggregateInsightDetailResponse =
  typeof ShopperAgentAggregateInsightDetailResponse.Type;

export const RelatedShopperAgentAggregateInsightSpan = Schema.Struct({
  startMessageId: MessageId,
  endMessageId: MessageId,
});
export type RelatedShopperAgentAggregateInsightSpan =
  typeof RelatedShopperAgentAggregateInsightSpan.Type;

export const RelatedShopperAgentAggregateInsight = Schema.Struct({
  topicId: TopicId,
  insightType: ShopperAgentAggregateInsightType,
  title: Schema.String,
  windowStart: Schema.Date,
  windowEnd: Schema.Date,
  spans: Schema.Array(RelatedShopperAgentAggregateInsightSpan),
});
export type RelatedShopperAgentAggregateInsight =
  typeof RelatedShopperAgentAggregateInsight.Type;
